import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
import { Margin } from '@freelancer/ui/margin';

@Component({
  selector: 'app-user-profile-skills-empty',
  template: `
    <fl-bit class="EmptyStateContainer">
      <fl-picture
        alt="No skills image"
        i18n-alt="No skills image"
        [src]="'contest-view-page/load-contest-error.svg'"
        [flMarginBottom]="Margin.XXSMALL"
      ></fl-picture>

      <fl-button
        i18n="Add skills button"
        flTrackingLabel="UserProfileEmptySkillsAddSkills"
        [color]="ButtonColor.DEFAULT"
        [display]="'block'"
        (click)="addSkills.emit()"
      >
        Add Skills
      </fl-button>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-skills-empty.component.scss'],
})
export class UserProfileSkillsEmptyComponent {
  ButtonColor = ButtonColor;
  Margin = Margin;

  @Output() addSkills = new EventEmitter<void>();
}
